<template>
  <DetailsSection 
    label="Check-in-Zeiten"
    type="last" 
  >
    <IndividualPanel />
  </DetailsSection>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DetailsSection from '../DetailsSection.vue';
import IndividualPanel from './IndividualPanel.vue';

export default defineComponent({
  components: { DetailsSection, IndividualPanel },
})
</script>
